export default "__VITE_ASSET__ntU3s1E8__"